import React, { Component } from "react";

import OrderRow from "./OrderRow";
import ProjectRow from "./ProjectRow";
import { withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/core/styles';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';

class OrderList extends Component {
	constructor(props) {
        super(props);
		//this.state= {
		//	page: 0,
		//	rowsPerPage: 25,
//		//	pending: []
		//}
		
		this.handleFirstPageButtonClick=this.handleFirstPageButtonClick.bind(this);
		this.handleBackButtonClick=this.handleBackButtonClick.bind(this);
		this.handleNextButtonClick=this.handleNextButtonClick.bind(this);
		this.handleLastPageButtonClick=this.handleLastPageButtonClick.bind(this);
		this.handleChangePage=this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage=this.handleChangeRowsPerPage.bind(this);
		this.orderOrdersDESC=this.orderOrdersDESC.bind(this);
		this.generaOrderRow=this.generaOrderRow.bind(this);
		this.generaProjectRow=this.generaProjectRow.bind(this);
    }
	
//	componentDidMount() {
//		console.log("componentDidMount (pending): "+this.state.pending.length);
//		this.timer = setInterval(() => this.props.checkPending(this.state.pending), 5000);
//    }
	
//	componentDidUpdate() {
//		console.log("componentDidUpdate (pending): "+this.state.pending.length);
//		if(this.state.pending.length==0){
//			console.log("componentDidUpdate es zero");
//			clearInterval(this.timer);
//			this.timer = null;
//		}
//    }
	
//	componentWillUnmount() {
//        clearInterval(this.timer);
//        this.timer = null;
//    }
	
	handleFirstPageButtonClick(event) {
		this.props.setPage(0);
	}
	
	handleBackButtonClick(event) {
		if(this.props.page>1){
			this.props.setPage(this.props.page-1);
		}
	}
	
	handleNextButtonClick(event) {
		if(this.props.page+1 > Math.max(0, Math.ceil(Object.keys(this.props.orders).length / this.props.rowsPerPage) - 1)){
			this.props.setPage(this.props.page+1);
		}
	}
	
	handleLastPageButtonClick(event) {
		this.props.setPage(Math.max(0, Math.ceil(Object.keys(this.props.orders).length / this.props.rowsPerPage) - 1));
	}
  
	handleChangePage(event, newPage) {
		this.props.setPage(newPage);
	}
	
	handleChangeRowsPerPage(event) {
		this.props.setRowsPerPage(parseInt(event.target.value, 10));
	}
	
	orderOrdersDESC(a, b){
		if(this.props.orders[a].date==this.props.orders[b].date){
			return this.props.orders[b].code.localeCompare(this.props.orders[a].code);
		}else{
			let date1 = new Date(this.props.orders[a].date);
			let date2 = new Date(this.props.orders[b].date);
			return ( date2 > date1 ) - ( date2 < date1 );
		}
	}
	
	getFileExtension(filename){
		return filename.split('.').pop();
	}
	
	generaOrderRow(order, inProject, projectOrders){
		let xlifDocumentId=0;
		let responsable="";
		let reviewer="";
		for (var i = 0; i < order.phase.length; i++) {
			if(order.phase[i].type=="TRANSLATION" || order.phase[i].type=="PROOF_PRINTING" || order.phase[i].type=="RATING"){
				if(order.phase[i].user!==null && this.props.users[order.phase[i].user]!=null){
					responsable = this.props.users[order.phase[i].user].username;
				}
				if((order.phase[i].type=="TRANSLATION" || order.phase[i].type=="RATING") 
					&& order.phase[i].document && order.phase[i].document.id
					&& this.getFileExtension(order.phase[i].document.filename)=="xlf"){
					xlifDocumentId=order.phase[i].document.id;
				}
			}else if(order.phase[i].type=="REVISION"){
				if(order.phase[i].user!==null && this.props.users[order.phase[i].user]!=null){
					reviewer = this.props.users[order.phase[i].user].username;
				}
			}
		}

		let lock = ((typeof order.lock !== "undefined") && ( order.lock!==null))? 1 : 0;
		//console.log("LOCK ["+order.code+"]: "+lock);
		return <OrderRow
					key={order.id}
					id={order.id}
					code={order.code}
					//customer={order.user.customer.name}
					customer={this.props.customers[this.props.users[order.user].customer].name}
					description={ order.phase[0].document.filename }
					orgDoc={typeof order.links !== "undefined" ? order.links.find(function(link){return link.rel=="SOURCE";}):""}
					//xlfDoc={order.phase.find(function(phase){return phase.type=="TRANSLATION";}).document.id}
					accessToken={this.props.accessToken}
					langPair={this.props.langPairs[order.langPair].code}
					responsable={responsable}
					reviewer={reviewer}
					task={order.task}
					urgent={order.urgent}
					recvd={order.date}
					finished={order.dateF}
					state={order.state}
					sendOdooC={order.sendOdooC}
					sendOdooT={order.sendOdooT}
					//finishActions={this.props.ordersFinishActions}
					qaAction={this.props.orderQaAction}
					sendOdooActions={this.props.sendOdooActions}
					deleteOrder={this.props.deleteOrder}
					unlockOrder={this.props.unlockOrder}
					words={order.wordCount}
					messages={order.messages}
					sendMessage={this.props.sendMessage}
					xlifDocumentId = {xlifDocumentId}
					helpDocument={typeof order.links !== "undefined" ? order.links.find(function(link){return link.rel=="ATACHMENT";}):""}
					xlfDocument={typeof order.links !== "undefined" ? order.links.find(function(link){return link.rel=="TRANSLATION";}):""}
					qaDocument={typeof order.links !== "undefined" ? order.links.find(function(link){return link.rel=="FORMAT_QA";}):""}
					revisionQaDocument={typeof order.links !== "undefined" ? order.links.find(function(link){return link.rel=="REVISION_FORMAT_QA";}):""}
					trgDocument={typeof order.links !== "undefined" ? order.links.find(function(link){return link.rel=="FINISHED";}):""}
					processInstanceId={order.processInstanceId}
					nonconformity={order.nonconformity}
					userName={this.props.userName}
					userRole={this.props.userRole}
					progres={order.progres}
					partial={order.partial}
					inProject={inProject}
					projectOrders={projectOrders}
					lock = {lock}
					viewTranslators = {this.props.viewTranslators}
				/>
	}
	
	generaProjectRow(project, referenceOrder, currentProjectOrders){
		let finishedDate="";
		let finishedPhase=project.phase.find(phase => phase.type=="FINISHED");
		if(typeof finishedPhase !== "undefined"){
			finishedDate=finishedPhase.document.date;
		}
		return <ProjectRow
					key={"p"+project.id}
					id={project.id}
					code={project.code}
					customer={this.props.customers[this.props.users[referenceOrder.user].customer].name}
					description={project.name}
					orgDoc={typeof project.links !== "undefined" ? project.links.find(function(link){return link.rel=="SOURCE";}):""}
					accessToken={this.props.accessToken}
					lang={this.props.langPairs[referenceOrder.langPair].code.slice(0,5)}
					urgent={referenceOrder.urgent}
					recvd={referenceOrder.date}
					finished={finishedDate}
					trgDocument={typeof project.links !== "undefined" ? project.links.find(function(link){return link.rel=="FINISHED";}):""}
					userName={this.props.userName}
					userRole={this.props.userRole}
					orderRows = {currentProjectOrders}
					viewTranslators = {this.props.viewTranslators}
					sendMessage={this.props.sendMessage}
					splitDocument={project.hasOwnProperty('partialSource')}
				/>
	}
	
	render() {
		const { t } = this.props;
		
		let project;
		let rows = [];
		
		let parentProject = [];
		let fets = [];
		if(this.props.orders){
			var keys = Object.keys(this.props.orders).filter(k => this.props.orders[k].state != "PREPROCESS").sort(this.orderOrdersDESC);
			if(keys.length>0){
				let veuMLT = this.props.userRole!=="TRANSLATOR";
				let veuSplitOrders = this.props.userRole==="TRANSLATOR" || this.props.userRole==="ADMIN";
	
				for (var orderIndex = 0; orderIndex < keys.length; orderIndex++) {
					const order = this.props.orders[keys[orderIndex]];
					const project = this.props.projects.find(project => project.id === order.projectId);
					if ((typeof project!=="undefined") && project.hasOwnProperty('mlt') && veuMLT){							// document multiidioma
						parentProject.push(project.id);
					}else if((typeof project!=="undefined") && project.hasOwnProperty('partialSource') && veuSplitOrders){	// document partit
						//parentProject.push(project.partialSource);
						parentProject.push(order.projectId);
					}else if((order.partial==="SOURCE") && veuSplitOrders){													// document partit original
						parentProject.push(-1);
					}else{
						parentProject.push(0);
					}
					fets[orderIndex]=0;
				}
				
				for (var orderIndex = 0; orderIndex < keys.length; orderIndex++) {
					const order = this.props.orders[keys[orderIndex]];
					const project = this.props.projects.find(project => project.id === order.projectId);
					
					if(order.user && this.props.users[order.user] && this.props.customers[this.props.users[order.user].customer] && this.props.langPairs[order.langPair] && typeof order.phase[0] !== "undefined" ){
						let projectOrders = [];
						if(fets[orderIndex]===0){
							if(parentProject[orderIndex]>0){
								if ((typeof project!=="undefined") && project.hasOwnProperty('mlt')){
									for(var i=0; i<keys.length; i++){
										if( (this.props.orders[keys[i]].projectId==parentProject[orderIndex]) && fets[i]==0){
												projectOrders.push(this.generaOrderRow(this.props.orders[keys[i]], parentProject[orderIndex], null));
												fets[i]=1;
										}
									}
									rows.push(this.generaProjectRow(project, order, projectOrders));
								}else if((typeof project!=="undefined") && project.hasOwnProperty('partialSource')){
									var sourceOrder = null;
									for(var i=0; i<keys.length; i++){
										if( (this.props.orders[keys[i]].projectId==parentProject[orderIndex]) && fets[i]==0){
												projectOrders.push(this.generaOrderRow(this.props.orders[keys[i]], parentProject[orderIndex], null));
												fets[i]=1;
										}else if(this.props.orders[keys[i]].id===project.partialSource){
											sourceOrder = this.props.orders[keys[i]];
											fets[i]=1;
										}
									}
									if(sourceOrder!==null){
										rows.push(this.generaOrderRow(sourceOrder, 0, projectOrders));
									}else{
										rows.push(this.generaProjectRow(project, order, projectOrders));
									}
								}
							}else if(parentProject[i]<0){
								//rows.push(this.generaOrderRow(order, 0, null));
							}else{
								rows.push(this.generaOrderRow(order, 0, null));
							}
							
							fets[orderIndex]=1;
						}
					}
				}
				
			}
		}
		return (
		  <table className="table table-striped table-hover lst">
		    <thead>
		      <tr>
				<th scope="col" className="smallcell d-lg-table-cell"></th>
		        <th scope="col" className="bigcell d-lg-table-cell">{t('customer')}</th>
				<th scope="col">{t('code')}</th>
				<th scope="col">{t('chat')}</th>
		        <th scope="col" className="bigcell">{t('document')}</th>
		        <th scope="col">{t('languages')}</th>
				<th scope="col">{t('state')}</th>
				{this.props.viewTranslators &&  <th className="medcell d-lg-table-cell">{t('translator')}</th>}
				{this.props.viewTranslators && (this.props.userRole!="TRANSLATOR") &&  <th className="medcell d-none d-lg-table-cell">Reviewer</th>}
				<th scope="col">{t('words_ct')}</th>
		        <th scope="col" className="d-lg-table-cell">{t('recived')}</th>
		        <th scope="col" className="d-none d-lg-table-cell">{t('finished')}</th>
				<th scope="col">{t('actions')}</th>
		      </tr>
		    </thead>
		    <tbody>{rows}</tbody>
		    <tfoot>
              <tr>
                <TablePagination
                  colSpan={11}
//                  count={keys.length}
				count={10000}
                  rowsPerPage={this.props.rowsPerPage}
                  page={this.props.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
//                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </tr>
            </tfoot>
		  </table>
		);
  }
};

//export default withStyles(styles)(OrderList);
export default withTranslation()(OrderList);